import { Component, Input, forwardRef, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription, combineLatest } from 'rxjs';
import { skip, startWith } from 'rxjs/operators';

@Component({
  selector: 'forms-country-state',
  templateUrl: './country-state.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryStateComponent),
      multi: true,
    },
  ],
  styles: [
    `
      mat-form-field {
        width: 100%;
      }
    `,
  ],
})
export class CountryStateComponent implements OnInit, OnChanges, OnDestroy {
  @Input() formControl: UntypedFormControl;
  @Input() countries: { value: string; label: string }[] = [];
  @Input() states: { value: string; label: string }[] = [];
  @Input() required = true;

  country: UntypedFormControl = new UntypedFormControl();
  state: UntypedFormControl = new UntypedFormControl();
  onChange: any;
  onTouched: any;
  subscriptions_: Subscription[] = [];
  ngOnInit(): void {
    if (this.required) {
      this.country.setValidators([Validators.required]);
      if (this.states.length !== 0) {
        this.state.setValidators([Validators.required]);
      }
    }
    this.subscriptions_.push(
      combineLatest([this.country.statusChanges, this.state.statusChanges]).subscribe(
        ([countryStatus, stateStatus]) => {
          if (countryStatus === 'VALID' && stateStatus === 'VALID') {
            this.formControl.setErrors(null);
          } else {
            this.formControl.setErrors({ required: true });
          }
        },
      ),
    );
  }

  ngOnChanges(changes: any): void {
    if (changes.states.currentValue.length === 0) {
      this.state.setValidators([]);
    } else if (this.required) {
      this.state.setValidators([Validators.required]);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions_.forEach((s) => s.unsubscribe());
  }

  writeValue(obj: any): void {
    this.country.setValue(obj.country);
    this.state.setValue(obj.state);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.subscriptions_.push(
      combineLatest([
        this.country.valueChanges.pipe(startWith(this.country.value)),
        this.state.valueChanges.pipe(startWith(this.state.value)),
      ])
        .pipe(skip(1))
        .subscribe(([country, state]) => {
          this.onChange({
            country: country,
            state: state,
          });
        }),
    );
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  get value(): { country: string; state: string } {
    return {
      country: this.country.value,
      state: this.state.value,
    };
  }

  set value(val: { country: string; state: string }) {
    this.country.setValue(val.country);
    this.state.setValue(val.state);
    if (this.onChange) {
      this.onChange(this.value);
    }
  }
}
